"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProjectFilter;
(function (ProjectFilter) {
    ProjectFilter["NotArchived"] = "NotArchived";
})(ProjectFilter = exports.ProjectFilter || (exports.ProjectFilter = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJvamVjdEZpbHRlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInByb2plY3RGaWx0ZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSxJQUFZLGFBRVg7QUFGRCxXQUFZLGFBQWE7SUFDckIsNENBQTJCLENBQUE7QUFDL0IsQ0FBQyxFQUZXLGFBQWEsR0FBYixxQkFBYSxLQUFiLHFCQUFhLFFBRXhCIn0=